import { inject, singleton } from 'tsyringe';
import { IListingEnricherConfig, ServerSettings } from './settings/server-settings';

@singleton()
export class ListingEnricherConfig {
  public readonly settings: IListingEnricherConfig;

  constructor(@inject(ServerSettings) serverSettings: ServerSettings) {
    this.settings = serverSettings.settings.listingEnricher;
  }
}
